import React, { Component, Fragment } from 'react'
import ReactDOM from 'react-dom'
import { connect } from 'react-redux'
import axios from 'axios'
import swal from 'sweetalert'
import '../../projects_project/style.css'
import { Modal, Button, Well, Table, Overlay, Popover } from 'react-bootstrap'

import { handleErrorFetchingData } from '../../../functions/errorHandling'
import getServerURL from '../../../functions/getServerURL'

import { updatePublication, removePublication, getPublicationFieldsData, getPublicationsWithFilters } from '../reducers/managePublications'

import AuthenticationComponent from '../../../AuthenticationComponent'

import PublicationOverviewField from './PublicationOverviewField'
import PublicationApprovalField from './PublicationApprovalField'
import ShowURLField from './ShowURLField'


class PublicationModal extends Component {

  state = {
    publication: null,
    fetchingPublication: false,
    publicationNotFound: false,
    showDeletePopover: false,
    showAllFieldsForManagement: false
  }

  componentDidUpdate(prevProps) {
    const { match, publications } = this.props

    const prevPropsHasId = !!prevProps.match && !!prevProps.match.params && !!prevProps.match.params.publication

    const currentPropsHasId = !!match && !!match.params && !!match.params.publication

    const prevPropsIdWasUpdated = (!prevPropsHasId && currentPropsHasId) ||
    (currentPropsHasId && prevProps.match.params.publication !== match.params.publication)


    if (prevPropsHasId && !currentPropsHasId) {
      this.setState({
        publication: null,
        fetchingPublication: false,
        publicationNotFound: false,
        showDeletePopover: false,
      })
    }

    if (prevPropsHasId )

    if (!prevPropsIdWasUpdated && this.state.publication) {
      return
    }

    if (this.state.fetchingPublication || this.state.publicationNotFound) {
      return
    }

    if (prevPropsIdWasUpdated || (currentPropsHasId && !this.state.publication)) {
      this.setState({ fetchingPublication: true })
      const publication = [...publications].find(pub => {
        return pub.id === match.params.publication
      })

      if (publication) {
        this.setState({ fetchingPublication: false, publication })
      } else {
        this.getPublication()
      }
    }

  }

  getPublication = () => {
    this.setState({ fetchingPublication: true })
    const publicationId = this.props.match.params.publication
    axios(`${getServerURL()}publications/${publicationId}/`,{
      headers: {
        "Authorization": "Bearer " + localStorage.getItem("token")
      },
    })
    .then(response => {
      this.setState({ fetchingPublication: false, publication: response.data })
    })
    .catch(error => {
      if (error && error.response && error.response.status && error.response.status === 404) {
        return this.setState({ fetchingPublication: false, publicationNotFound: true })
      }
      const message = "There was an error fetching the publication"
      handleErrorFetchingData(error, message)
    })
  }

  editPublication = (key, value) => {
    let { publication } = this.state

    let updatedValue = value

    const formData = new FormData()

    if (Array.isArray(updatedValue)) {
      updatedValue = updatedValue.forEach(item => {
        if (!!item.customOption) {
          formData.append(`new_${key}`, item.name)
        } else {
          formData.append(key, item.url)
        }
      })
    } else if (typeof updatedValue === "string") {
      updatedValue = updatedValue
        .replace("<p>", "")
        .replace("</p>", "")
      formData.append(key, updatedValue)
    } else {
      formData.append(key, value)
    }

    swal({
      text: "Editing the publication... Please stand by.",
      icon: require("../../../static/images/spinner.gif"),
      button: false,
      closeOnClickOutside: false,
    })
    axios({
      method: "PATCH",
      url: publication.url,
      data: formData,
      headers: {"Authorization": "Bearer " + localStorage.getItem("token")}
    })
    .then(response => {
      swal({
        title: "Success",
        text: "Publication has been updated",
        icon: "success",
        button: "Continue",
      })

      if (key === 'document') {
        publication = { ...publication, ...response.data, authors: publication.authors }
      } if (key === "publication_url") {
        publication = { ...publication, show_url_on_website: response.data.show_url_on_website }
      } else {
        publication = { ...publication, [key]: value }
      }
      this.props.getPublicationsWithFilters(this.props.currentPublicationsPage, this.props)
      // this.props.updatePublication(publication)
      // this.props.getPublicationFieldsData()
      return this.setState({ publication })
    })
    .catch(error => {
      const message = "There was an error editing your publication"
      return handleErrorFetchingData(error, message)
    })
  }

  approvePublication = () => {
    let { publication } = this.state

    const formData = new FormData()
    formData.append("is_approved", !publication.is_approved)

    swal({
      text: `${!publication.is_approved ? "Approving" : "Unapproving"} the publication... Please stand by.`,
      icon: require("../../../static/images/spinner.gif"),
      button: false,
      closeOnClickOutside: false,
    })
    axios({
      method: "PATCH",
      url: publication.url,
      data: formData,
      headers: {"Authorization": "Bearer " + localStorage.getItem("token")}
    })
    .then(response => {
      swal({
        title: "Success",
        text: `Publication has been ${!publication.is_approved ? "approved" : "unapproved"}`,
        icon: "success",
        button: "Continue",
      })

      publication = { ...publication, "is_approved": !publication.is_approved }
      this.props.getPublicationsWithFilters(this.props.currentPublicationsPage, this.props)
      return this.setState({ publication })
    })
    .catch(error => {
      const message = `There was an error ${!publication.is_approved ? "approving" : "unapproving"} your publication`
      return handleErrorFetchingData(error, message)
    })
  }

  deletePublication = () => {
    const { publication } = this.state

    this.setState({ showDeletePopover: false })

    swal({
      text: "Deleting the publication... Please stand by.",
      icon: require("../../../static/images/spinner.gif"),
      button: false,
      closeOnClickOutside: false,
    })
    axios({
      method: "DELETE",
      url: publication.url,
      headers: {"Authorization": "Bearer " + localStorage.getItem("token")}
    })
    .then(response => {
      swal({
        title: "Success",
        text: "Publication has been deleted",
        icon: "success",
        button: "Continue",
      })
      .then(() => {
        this.props.removePublication(publication.id)
        this.props.history.push('/publications')
      })
    })
    .catch(error => {
      const message = "There was an error deleting your publication"
      return handleErrorFetchingData(error, message)
    })
  }

  toggleDeletePopover = () => this.setState({ showDeletePopover: !this.state.showDeletePopover })


  handleClose = () => {
    this.setState({ fetchingPublication: false, publicationNotFound: false })
    this.props.history.push('/publications')
  }

  renderTitle = () => {
    const { publication } = this.state

    if (publication && publication.citation && publication.citation.length > 100) {
      return publication.citation.slice(0, 100) + '...'
    } else if (publication) {
      return publication.citation
    } else {
      return "Loading..."
    }
  }

  getManagedPublicationModalClassName = () => {
    const { publication } = this.state
    const pubClassName = "publication-show-modal"
    if (!this.props.publicationManagementMode) return pubClassName

    if (publication && publication.citation.length && publication.therapeutic_areas.length && !isNaN(publication.year)) {
      if (publication.is_approved) {
        return pubClassName + " pub-modal-green"
      } else {
        return pubClassName + " pub-modal-yellow"
      }
    } else {
      return pubClassName + " pub-modal-red"
    }
  }


  render() {
    const {
      match,
      genesisUsers,
      therapeuticAreas,
      studyDesigns,
      dataSources,
      dataSourceTypes,
      methodAnalysisTypes,
      publicationTypes,
    } = this.props

    const {
      publication,
      fetchingPublication,
      publicationNotFound
    } = this.state

    if (!match || !match.params || !match.params.publication) {
      return null
    } else {
      return (
        <Modal show={true} dialogClassName={this.getManagedPublicationModalClassName()}>
          <AuthenticationComponent />
          <Modal.Header closeButton onHide={this.handleClose}>
            <Modal.Title>
              <span dangerouslySetInnerHTML={{__html: this.renderTitle()}}></span>
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            {! publicationNotFound && (!publication || fetchingPublication) ?
              <center>
                <img alt="loader" src={require("../../../static/images/spinner.gif")} />
              </center>
              :
              <Well>
              {publicationNotFound ?
                <center>
                  <h4>
                    Publication not found
                  </h4>
                </center>
                :
                <Fragment>
                  {this.props.publicationManagementMode ?
                    <Fragment>
                      <PublicationApprovalField
                        publication={publication}
                        isApproved={publication.is_approved}
                        approvePublication={this.approvePublication}
                      />
                      <hr/>
                    </Fragment>
                    :
                    null
                  }
                  {this.props.publicationManagementMode && !this.state.showAllFieldsForManagement ?
                    <Table responsive className='publication-show-table'>
                      <tbody>
                        <tr>
                          <td>
                            <strong>
                              Citation
                            </strong>
                          </td>
                          <PublicationOverviewField
                            text={publication.citation}
                            fieldName='citation'
                            editPublication={this.editPublication}
                          />
                        </tr>
                        <tr>
                          <td>
                            <strong>
                              Year
                            </strong>
                          </td>
                          <PublicationOverviewField
                            text={publication.year}
                            fieldName='year'
                            editPublication={this.editPublication}
                          />
                        </tr>
                        <tr>
                          <td>
                            <strong>
                              Therapeutic Area(s)
                            </strong>
                          </td>
                          <PublicationOverviewField
                            text={publication.therapeutic_areas.map(therapeuticArea => therapeuticArea.name).join(', ')}
                            array={publication.therapeutic_areas}
                            labelKey={(therapeuticArea) => `${therapeuticArea.name}`}
                            options={therapeuticAreas}
                            allowMultipleSelections={true}
                            fieldName='therapeutic_areas'
                            editPublication={this.editPublication}
                          />
                        </tr>
                        <tr>
                          <td>
                            <strong>
                              URL
                            </strong>
                          </td>
                          <PublicationOverviewField
                            text={publication.publication_url}
                            fieldName='publication_url'
                            editPublication={this.editPublication}
                          />
                        </tr>
                        <ShowURLField
                          publication={publication}
                          editPublication={this.editPublication}
                        />
                      </tbody>
                    </Table>
                    :
                    <Table responsive className='publication-show-table'>
                      <tbody>
                        <tr>
                          <td>
                            <strong>
                              Citation
                            </strong>
                          </td>
                          <PublicationOverviewField
                            text={publication.citation}
                            fieldName='citation'
                            editPublication={this.editPublication}
                          />
                        </tr>

                        <tr>
                          <td>
                            <strong>
                              Genesis Author(s)
                            </strong>
                          </td>
                          <PublicationOverviewField
                            text={publication.authors.map(author => `${author.first_name} ${author.last_name}`).join(', ')}
                            array={publication.authors}
                            labelKey={(author) => `${author.first_name} ${author.last_name}`}
                            options={genesisUsers}
                            allowMultipleSelections={true}
                            fieldName='authors'
                            editPublication={this.editPublication}
                          />
                        </tr>

                        <tr>
                          <td>
                            <strong>
                              Year
                            </strong>
                          </td>
                          <PublicationOverviewField
                            text={publication.year}
                            fieldName='year'
                            editPublication={this.editPublication}
                          />
                        </tr>

                        <tr>
                          <td>
                            <strong>
                              Month
                            </strong>
                          </td>
                          <PublicationOverviewField
                            text={publication.month}
                            fieldName='month'
                            editPublication={this.editPublication}
                          />
                        </tr>

                        <tr>
                          <td>
                            <strong>
                              Client
                            </strong>
                          </td>
                          <PublicationOverviewField
                            text={publication.publication_client}
                            fieldName='publication_client'
                            editPublication={this.editPublication}
                          />
                        </tr>

                        <tr>
                          <td>
                            <strong>
                              Journal/Conference
                            </strong>
                          </td>
                          <PublicationOverviewField
                            text={publication.journal_conference}
                            fieldName='journal_conference'
                            editPublication={this.editPublication}
                          />
                        </tr>

                        <tr>
                          <td>
                            <strong>
                              Product
                            </strong>
                          </td>
                          <PublicationOverviewField
                            text={publication.product}
                            fieldName='product'
                            editPublication={this.editPublication}
                          />
                        </tr>

                        <tr>
                          <td>
                            <strong>
                              Indication
                            </strong>
                          </td>
                          <PublicationOverviewField
                            text={publication.indication}
                            fieldName='indication'
                            editPublication={this.editPublication}
                          />
                        </tr>

                        {/* <tr>
                          <td>
                            <strong>
                              Therapeutic Area
                            </strong>
                          </td>
                          <PublicationOverviewField
                            text={publication.therapeutic_area}
                            fieldName='therapeutic_area'
                            editPublication={this.editPublication}
                          />
                        </tr> */}

                        <tr>
                          <td>
                            <strong>
                              Therapeutic Area(s)
                            </strong>
                          </td>
                          <PublicationOverviewField
                            text={publication.therapeutic_areas.map(therapeuticArea => therapeuticArea.name).join(', ')}
                            array={publication.therapeutic_areas}
                            labelKey={(therapeuticArea) => `${therapeuticArea.name}`}
                            options={therapeuticAreas}
                            allowMultipleSelections={true}
                            fieldName='therapeutic_areas'
                            editPublication={this.editPublication}
                          />
                        </tr>

                        {/* <tr>
                          <td>
                            <strong>
                              Publication Type
                            </strong>
                          </td>
                          <PublicationOverviewField
                            text={publication.publication_type}
                            fieldName='publication_type'
                            editPublication={this.editPublication}
                          />
                        </tr> */}

                        <tr>
                          <td>
                            <strong>
                              Publication Types
                            </strong>
                          </td>
                          <PublicationOverviewField
                            text={publication.publication_types.map(publicationType => publicationType.name).join(', ')}
                            array={publication.publication_types}
                            labelKey={(publicationType) => `${publicationType.name}`}
                            options={publicationTypes}
                            allowMultipleSelections={true}
                            fieldName='publication_types'
                            editPublication={this.editPublication}
                          />
                        </tr>

                        {/* <tr>
                          <td>
                            <strong>
                              Analysis Type
                            </strong>
                          </td>
                          <PublicationOverviewField
                            text={publication.analysis_type}
                            fieldName='analysis_type'
                            editPublication={this.editPublication}
                          />
                        </tr> */}

                        <tr>
                          <td>
                            <strong>
                              Method / Analysis Type(s)
                            </strong>
                          </td>
                          <PublicationOverviewField
                            text={publication.method_analysis_types.map(methodAnalysisType => methodAnalysisType.name).join(', ')}
                            array={publication.method_analysis_types}
                            labelKey="name"
                            options={methodAnalysisTypes}
                            allowNew={true}
                            allowMultipleSelections={true}
                            fieldName='method_analysis_types'
                            editPublication={this.editPublication}
                          />
                        </tr>

                        <tr>
                          <td>
                            <strong>
                              Study Design(s)
                            </strong>
                          </td>
                          <PublicationOverviewField
                            text={publication.study_designs.map(studyDesign => studyDesign.name).join(', ')}
                            array={publication.study_designs}
                            labelKey="name"
                            options={studyDesigns}
                            allowMultipleSelections={true}
                            fieldName='study_designs'
                            editPublication={this.editPublication}
                          />
                        </tr>

                        {/* <tr>
                          <td>
                            <strong>
                              Database
                            </strong>
                          </td>
                          <PublicationOverviewField
                            text={publication.database}
                            fieldName='database'
                            editPublication={this.editPublication}
                          />
                        </tr> */}

                        <tr>
                          <td>
                            <strong>
                              Data Source(s)
                            </strong>
                          </td>
                          <PublicationOverviewField
                            text={publication.data_sources.map(dataSource => dataSource.name).join(', ')}
                            array={publication.data_sources}
                            labelKey="name"
                            options={dataSources}
                            allowNew={true}
                            allowMultipleSelections={true}
                            fieldName='data_sources'
                            editPublication={this.editPublication}
                          />
                        </tr>

                        <tr>
                          <td>
                            <strong>
                              Data Source Type(s)
                            </strong>
                          </td>
                          <PublicationOverviewField
                            text={publication.data_source_types.map(dataSourceType => dataSourceType.name).join(', ')}
                            array={publication.data_source_types}
                            labelKey="name"
                            options={dataSourceTypes}
                            allowNew={true}
                            allowMultipleSelections={true}
                            fieldName='data_source_types'
                            editPublication={this.editPublication}
                          />
                        </tr>

                        <tr>
                          <td>
                            <strong>
                              Document
                            </strong>
                          </td>
                          <PublicationOverviewField
                            text={publication.document}
                            fieldName='document'
                            editPublication={this.editPublication}
                            publication={publication}
                          />
                        </tr>

                        <tr>
                          <td>
                            <strong>
                              Done With Genesis / Sirius / MAT
                            </strong>
                          </td>
                          <PublicationOverviewField
                            text={publication.done_with_genesis}
                            fieldName='done_with_genesis'
                            editPublication={this.editPublication}
                            publication={publication}
                          />
                        </tr>

                        <tr>
                          <td>
                            <strong>
                              Regulatory Related
                            </strong>
                          </td>
                          <PublicationOverviewField
                            text={publication.regulatory_related}
                            fieldName='regulatory_related'
                            editPublication={this.editPublication}
                            publication={publication}
                          />
                        </tr>

                        <tr>
                          <td>
                            <strong>
                              URL
                            </strong>
                          </td>
                          <PublicationOverviewField
                            text={publication.publication_url}
                            fieldName='publication_url'
                            editPublication={this.editPublication}
                          />
                        </tr>
                        {this.props.publicationManagementMode ?
                          <ShowURLField
                            publication={publication}
                            editPublication={this.editPublication}
                          />
                          :
                          null
                        }
                      </tbody>
                    </Table>
                    }
                    {this.props.publicationManagementMode ?
                      <Fragment>
                        <a style={{cursor: "pointer"}} onClick={() => this.setState({...this.state, showAllFieldsForManagement: !this.state.showAllFieldsForManagement})}>Show {`${this.state.showAllFieldsForManagement ? "less fields ∧∧∧" : "all fields ∨∨∨"}`}</a>
                        <br />
                        <br />
                      </Fragment>
                      :
                      null
                    }

                    {/* {this.props.currentUser.is_manager ? */}
                      <Button
                        bsStyle='danger'
                        ref={button => this.target = button}
                        onClick={this.toggleDeletePopover}
                      >
                        Delete
                      </Button>
                      {/* :
                      null
                    } */}

                    <Overlay
                      show={this.state.showDeletePopover}
                      onHide={this.toggleDeletePopover}
                      placement="right"
                      target={() => ReactDOM.findDOMNode(this.target)}
                    >
                      <Popover id="delete-publication-popover" title="Delete Publication?">
                        <p>
                          Are you sure you want to delete this publication?
                        </p>
                        <br/>
                        <p>
                          <strong>This action is irreversible.</strong>
                        </p>
                        <br/>
                        <center>
                        <Button
                          bsStyle='danger'
                          style={{marginRight: '5px'}}
                          onClick={this.deletePublication}
                        >
                          Delete
                        </Button>
                        <Button
                          style={{marginLeft: '5px'}}
                          onClick={this.toggleDeletePopover}
                        >
                          Cancel
                        </Button>
                        </center>
                      </Popover>
                    </Overlay>
                  </Fragment>
              }
              </Well>

            }
          </Modal.Body>

          <Modal.Footer>
            <Button onClick={this.handleClose}>
            Close
            </Button>
          </Modal.Footer>
        </Modal>
      )
    }
  }
}

const mapStateToProps = (state) => {
  return {
    // REDUX METADATA //
    filteredPublicationCount: state.managePublications.filteredPublicationCount,
    publicationsPerPage: state.managePublications.publicationsPerPage,
    currentPublicationsPage: state.managePublications.currentPublicationsPage,
    publicationManagementMode: state.managePublications.publicationManagementMode,
    // DATA //
    currentUser: state.manageLogin.user,
    genesisUsers: state.manageLogin.genesisUsers,
    publications: state.managePublications.publications,
    therapeuticAreas: state.managePublications.therapeuticAreas,
    studyDesigns: state.managePublications.studyDesigns,
    dataSources: state.managePublications.dataSources,
    dataSourceTypes: state.managePublications.dataSourceTypes,
    methodAnalysisTypes: state.managePublications.methodAnalysisTypes,
    publicationTypes: state.managePublications.publicationTypes,
    // FILTERS & SORTING //
    publicationsSearchTerm: state.managePublications.publicationsSearchTerm,
    publicationsSortType: state.managePublications.publicationsSortType,
    publicationsApprovalStatusSortType: state.managePublications.publicationsApprovalStatusSortType,
    publicationsApprovalStatusFilter: state.managePublications.publicationsApprovalStatusFilter,
    publicationsAuthorFilter: state.managePublications.publicationsAuthorFilter,
    publicationsYearFilter: state.managePublications.publicationsYearFilter,
    publicationsClientFilter: state.managePublications.publicationsClientFilter,
    publicationsProductFilter: state.managePublications.publicationsProductFilter,
    publicationsIndicationFilter: state.managePublications.publicationsIndicationFilter,
    publicationsTherapeuticAreasFilter: state.managePublications.publicationsTherapeuticAreasFilter,
    publicationsStudyDesignsFilter: state.managePublications.publicationsStudyDesignsFilter,
    publicationsPublicationTypeFilter: state.managePublications.publicationsPublicationTypeFilter,
    publicationsMethodAnalysisTypesFilter: state.managePublications.publicationsMethodAnalysisTypesFilter,
    publicationsDataSourcesFilter: state.managePublications.publicationsDataSourcesFilter,
    publicationsDataSourceTypesFilter: state.managePublications.publicationsDataSourceTypesFilter,
    publicationsDoneWithGenesis: state.managePublications.publicationsDoneWithGenesis,
    publicationsRegulatoryRelated: state.managePublications.publicationsRegulatoryRelated,
  }
}

const mapDispatchToProps = {
  updatePublication,
  removePublication,
  getPublicationFieldsData,
  getPublicationsWithFilters
}

export default connect(mapStateToProps, mapDispatchToProps)(PublicationModal)



// WEBPACK FOOTER //
// ./src/routes/publications/components/PublicationModal.js